<div class="container">
  <div class="row">
    <div class="col-md-8 col-md-offset-2 wpb_text_column">
      @for (paragraph of page().paragraphs; track $index) {
        <p>{{ paragraph }}</p>
      }
    </div>
  </div>
</div>
